export function getStudyLogo(user) {
  const logo = user?.societe_logo;
  if (typeof logo !== "string" || logo.length > 1398127) return null;
  return /^data:image\/(png|jpeg);base64,[A-Za-z0-9+/]+={0,2}$/.test(logo) ? logo : null;
}
